const ITEMS = [
  "Full Refurbishments",
  "Painting & Decorating",
  "Bathroom Installations",
  "Kitchen Installations",
  "End of Tenancy Cleaning",
];

const Row = ({ ariaHidden = false }) => (
  <div aria-hidden={ariaHidden} className="flex items-center shrink-0">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="font-serif italic text-4xl md:text-6xl text-white/20 whitespace-nowrap px-6 md:px-12">
          {item}
        </span>
        <span className="w-2.5 h-2.5 rotate-45 bg-[#c5832b]/60 shrink-0" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <section
      data-testid="services-marquee"
      className="relative py-14 md:py-20 border-y border-white/10 overflow-hidden bg-[#121212]"
    >
      <div className="marquee-track">
        <Row />
        <Row ariaHidden />
      </div>
    </section>
  );
}
